import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {utcToLocal} from '../../utils/dateConvert'

class EventTable extends Component {
    render() {
        return (
            <div>
                
            <Table striped>
<thead>
<tr>
  
  <th>Type</th>
  <th>Configuration</th>
  <th>Created</th>
  <th>Updated</th>
  <th>Status</th>
  <th>Name</th>
  <th>Description</th>
  <th  style={{width:'200px'}}></th>


</tr>
</thead>
<tbody>
    
 {this.props.EventsList.map((events,index)=>{
     return(    <tr>
 <td>{events.type}</td>
          <td>{events.config}</td>
          <td>{utcToLocal(events.dbCreated)}</td>
          <td>{utcToLocal(events.dbUpdated)}</td>
          <td>{events.status==0?'Disabled':'Active'}</td>
          <td>{events.name}</td>
          <td>{events.description}</td>
          <td><Link to={`/editEvent/${events.id}`}>Edit</Link> | <Link to={`/eventDetails/${events.id}`}>Details</Link> | <Link to={`/eventDelete/${events.id}`}>Delete</Link></td>
        </tr>
       )
 })} 

</tbody>
</Table>
        </div>
        );
    }
}

export default EventTable;